import { Icon } from '@components/primitives/Icon'
import type { IconDefinition } from '@fortawesome/fontawesome-common-types'

export function HighlightTag({
  icon,
  value,
}: {
  icon: IconDefinition
  value: string
}) {
  return (
    <div className='flex rounded-full py-0.5'>
      <Icon className='pr-2 text-primary500' icon={icon} size='1x' />
      <span className='text-nowrap text-xs font-semibold leading-normal'>
        {value}
      </span>
    </div>
  )
}
